import { render, staticRenderFns } from "./CompanyLegalModal.vue?vue&type=template&id=29a82aaa"
import script from "./CompanyLegalModal.vue?vue&type=script&lang=js"
export * from "./CompanyLegalModal.vue?vue&type=script&lang=js"
import style0 from "./CompanyLegalModal.vue?vue&type=style&index=0&id=29a82aaa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports